export default __webpack_public_path__ + "static/intro_mobile-26db96f31a2c33b323db70cf38797bc1.mp4";